<script>
	import { adminUpdateSeasonsEntry } from '../AdminModule.svelte'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import TwoCols from '../../../library/columLayouts/TwoCols.svelte'
	import SeasonsPreview from './SeasonsPreview.svelte'
	import SeasonsEntry from './SeasonsEntry.svelte'

	//holds the season objects
	let seasons = []

	//load the menu from db
	const fetch_seasons_from_db = async () => {
		const fetchSeasons = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_seasons',
			}),
		})

		const dataResponse = await fetchSeasons.json()

		if (dataResponse.fetch === 0 || !dataResponse.fetch) {
			adminUpdateSeasonsEntry.set('[]')
			return
		}

		dataResponse.fetch.forEach((item) => {
			let tmpItem = {
				name: item[0],
				start: item[1],
				end: item[2],
			}

			//add the item at the beginning of the array menu
			seasons.push(tmpItem)
		})

		adminUpdateSeasonsEntry.set(JSON.stringify(seasons))
	}

	fetch_seasons_from_db()
</script>

<TwoCols column="290px" alignVertical="start">
	<div slot="column1">
		<SeasonsEntry />
	</div>

	<div slot="column2">
		<SeasonsPreview />
	</div>
</TwoCols>
